import { render, staticRenderFns } from "./ReceiptPreviewForm.vue?vue&type=template&id=1b8c309e"
import script from "./ReceiptPreviewForm.vue?vue&type=script&lang=js"
export * from "./ReceiptPreviewForm.vue?vue&type=script&lang=js"
import style0 from "./ReceiptPreviewForm.vue?vue&type=style&index=0&id=1b8c309e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports